import React, { useState, useEffect } from "react";
import { Div, Text, Row, Col, Image } from "atomize";
import CustomContainer from "../common/CustomContainer";
import { Anchor } from "atomize/dist";
import Swiper from "react-id-swiper";
import Div100vh from "react-div-100vh";

import HowSlide from "./HowSlide";
import HowVideoSlide from "./HowVideoSlide";
import HowThumbnail from "./HowThumbnail";
import HowModal from "../../modals/HowModal";

const HowItWorksSlider = ({ items }) => {
  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [modal, showModal] = useState(false);
  const [clicked, videoClicked] = useState(false);

  const gallerySwiperParams = {
    slidesPerView: 1,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    getSwiper: getGallerySwiper,
    effect: "fade",
    noSwiping: true,
  };

  const thumbnailSwiperParams = {
    getSwiper: swiper => {
      swiper.on("slideChange", () => onSlideChange(swiper.realIndex));
      getThumbnailSwiper(swiper);
    },
    direction: "horizontal",
    slidesPerView: "auto",
    spaceBetween: 16,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    centeredSlides: true,
    touchRatio: 1,
    slideToClickedSlide: true,
  };

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
    // if (localStorage.getItem("modalState") !== "false") {
    //   // Make the condition to '!== "false"' for 3 clicks
    //   showModal(true);
    // }
  }, [gallerySwiper, thumbnailSwiper]);

  const onSlideChange = value => {
    setCurrentSlide(value);
    let activeThumb =
      document &&
      document.querySelector(".how-thumbs-swiper .swiper-slide-active");
    const count = items.length;

    if (activeThumb) {
      for (let i = 0; i < count; i++) {
        if (value !== i) {
          activeThumb.parentNode.classList.remove(`slide${i + 1}-active`);
        }
      }

      if (value < 4) {
        activeThumb.parentNode.classList.add(`slide${value + 1}-active`);
      } else {
        activeThumb.parentNode.classList.add(`slide4-active`);
      }
    }
  };

  // if (modal) {
  //   localStorage.setItem("modalState", true);
  // }

  // const modalOnClick = e => {
  //   if (
  //     localStorage.getItem("modalState") === "true" ||
  //     localStorage.getItem("modalState") === "false"
  //   ) {
  //     localStorage.removeItem("clicked");
  //   } else {
  //     let clickCount = parseInt(localStorage.getItem("clicked"))
  //       ? parseInt(localStorage.getItem("clicked"))
  //       : 0;
  //     localStorage.setItem("clicked", clickCount);
  //     if (e) {
  //       let click = parseInt(localStorage.getItem("clicked"));
  //       localStorage.setItem("clicked", ++click);
  //     }
  //     if (clickCount === 2) {
  //       showModal(!modal);
  //     }
  //   }
  // };

  // const toggleModal = val => {
  //   showModal(val);
  // };

  return (
    <>
      <Div>
        {/* <HowSlide /> */}
        <Div100vh
          className="video-slider-wrapper"
          style={{ height: "calc(100rvh - 144px)" }}
        >
          <Div
            className="how-full-slider"
            h="100%"
            onClick={() => videoClicked(true)}
          >
            <Swiper {...gallerySwiperParams}>
              {items.map((item, index) => {
                return (
                  <div>
                    <HowVideoSlide
                      key={`howSlide-slider-${index}`}
                      content={item.node}
                      currentSlide={currentSlide}
                      index={index}
                      swiper={gallerySwiper}
                      pause={modal}
                      clicked={clicked}
                    />
                  </div>
                );
              })}
            </Swiper>
          </Div>
        </Div100vh>
        <Div
          bg="black800"
          overflow="hidden"
          className="how-thumbs-swiper"
          pos="relative"
          border={{ t: "1px solid" }}
          borderColor="border"
        >
          <Swiper {...thumbnailSwiperParams}>
            {items.map((item, index) => {
              return (
                <div>
                  <HowThumbnail
                    key={`howThumbs-slider-${index}`}
                    content={item.node}
                    currentSlide={currentSlide}
                    index={index}
                  />
                </div>
              );
            })}
          </Swiper>
        </Div>
        {/* <Div className="how-swiper-wrapper">
          <HowModal isOpen={modal} onClose={() => showModal(!modal)} />
        </Div> */}
      </Div>
    </>
  );
};

export default HowItWorksSlider;
